import { useState, useEffect } from 'react'

// Typical desktop breakpoint
const MIN_DESKTOP_WIDTH = 992

const checkIsMobile = (): boolean => {
  if (window.innerWidth < MIN_DESKTOP_WIDTH) {
    return true
  }
  return false
}

export default function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(checkIsMobile)

  useEffect(() => {
    const handleResize = (): void => {
      setIsMobile(checkIsMobile)
    }

    window.addEventListener('resize', handleResize)
    return (): void => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}
